import { render, staticRenderFns } from "./dietStatisticList.vue?vue&type=template&id=54710a0b"
import script from "./dietStatisticList.vue?vue&type=script&lang=js"
export * from "./dietStatisticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports